import cx from "classnames";
import React, { ReactNode } from "react";
import Popover, { PopoverProps } from "@mui/material/Popover";

import { makeStyles } from "../../theme/Theme";
import { getBrowserType } from "../../utils/DeviceUtils";

const useStyles = makeStyles((theme) => ({
  paper: {
    "&.MuiPaper-root": {
      boxShadow: "none",
      padding: theme.typography.pxToRem(16),
      marginTop: theme.typography.pxToRem(-34),
      marginLeft: theme.typography.pxToRem(-2),
      backgroundColor: theme.palette.common.transparent,
    },
  },
  root: {
    position: "relative",
    boxShadow: "0px 0px 1px 0px rgba(0, 0, 0, 0.3)",
    borderRadius: "8px",
  },
  arrow: {
    position: "absolute",
    top: "24px",
    left: "-9px",
    transform: "rotate(-45deg) skew(10deg, 10deg) !important",
    width: "24px !important",
    height: "24px !important",
    backgroundColor: theme.palette.walter.main,
    borderRadius: "6px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    padding: theme.typography.pxToRem(0),
    borderRadius: theme.typography.pxToRem(8),
    backgroundColor: theme.palette.walter.main,
    position: "relative",
    zIndex: 1000,
  },
}));

const getBrowserFilterClass = (): string => {
  const browserType = getBrowserType();
  switch (browserType) {
    case "firefox":
      return "filter-firefox";
    case "chrome":
      return "filter-chrome";
    default:
      return "filter-default";
  }
};

export interface PopupButtonPopoverProps extends Omit<PopoverProps, "children"> {
  readonly content: ReactNode;
  readonly className?: string;
  readonly withArrow?: boolean;
  readonly contentClassName?: string;
}

export function PopupButtonPopover({
  content,
  className,
  withArrow = true,
  PaperProps,
  contentClassName,
  ...props
}: PopupButtonPopoverProps) {
  const classes = useStyles();
  const browserFilterClass = getBrowserFilterClass();

  return (
    <Popover
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      {...props}
      PaperProps={{
        elevation: 0,
        ...PaperProps,
        className: cx(classes.paper, PaperProps?.className),
      }}
      sx={PaperProps?.sx}
    >
      <div className={cx(classes.root, className)}>
        {withArrow && <div className={cx(classes.arrow, browserFilterClass)} />}
        <div className={cx(classes.content, contentClassName)}>{content}</div>
      </div>
    </Popover>
  );
}
